import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUserRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 27,
	viewBox: "0 0 22 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6687 13.6852C16.1716 13.6852 19.0113 10.8455 19.0113 7.34259C19.0113 3.83968 16.1716 1 12.6687 1C9.16584 1 6.32617 3.83968 6.32617 7.34259C6.32617 10.8455 9.16584 13.6852 12.6687 13.6852Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 26.3703C1.72354 23.8754 3.2173 21.6732 5.26777 20.0784C7.31824 18.4836 9.82044 17.5779 12.4167 17.4907",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 26L21 19",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 19L21 26",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconUserRemove;
